/** CSS contract: css-library/components/01-leaves/card.css. */
import type { Ref } from 'react';
import { type HTMLAttributes, type ReactNode } from 'react';
import { Card, CardBody, CardHeader } from './Card';
import { cx } from '../lib/cx';

export interface UploadFieldProps extends Omit<HTMLAttributes<HTMLElement>, 'title' | 'children'> {
  title: string;
  description: ReactNode;
  loading?: boolean;
  loadingLabel: string;
  disabled?: boolean;
  invalid?: boolean;
  dragOver?: boolean;
}

export function UploadField(
  { ref, title, description, loading = false, loadingLabel, disabled = false, invalid = false, dragOver = false, className, ...props }: UploadFieldProps & { ref?: Ref<HTMLElement> },
) {
  return <Card {...props} ref={ref} className={cx('upload-field', className)} isColumnHeader droppable
    isLoading={loading} loadingLabel={loadingLabel} isDisabled={disabled} isDragOver={dragOver}
    aria-label={props['aria-label'] ?? title} aria-invalid={invalid || undefined}>
    <CardHeader>{title}</CardHeader>
    {description && <CardBody>{description}</CardBody>}
  </Card>;
}
